export const ESGImpactTypes = {
  ENVIRONMENT: 'environment',
  SOCIAL: 'social',
  GOVERNANCE: 'governance',
  TOTAL: 'total',
};
